import type { ApiRoutes } from '@tempo-io/notification-app/rpc';
import { createHonoRpcClient } from './hono-rpc-client';

export const getNotificationServiceApi = createHonoRpcClient<ApiRoutes>('/api/');
